<template>
  <div class="steps-content clearfix">
    <div
      v-for="step in steps"
      :key="step.text"
      :class="step.text === currentStep?.text ? 'active' : ''"
      class="step"
      :style="stepWidth">
      <p>{{ step.text }}</p>
    </div>
    <div class="fake-background transition-slow" :style="`${stepWidth} ${stepPosition}`" />
  </div>
</template>
<script>
export default {
  name: 'StepsBar',
  props: {
    steps: { type: Array, default: () => [] }
  },
  computed: {
    currentPath() {
      const pathSplit = this.$route.path.split('/');
      return pathSplit[pathSplit.length - 1];
    },
    currentStep() {
      return this.steps.find(step => {
        return step.paths.map(({ path }) => path).includes(this.currentPath);
      });
    },
    stepWidth() {
      return `width: ${100 / this.steps.length}%;`;
    },
    stepPosition() {
      let number;
      this.steps.every((step, i) => step.paths.every(({ path }) => {
        number = i;
        return path !== this.currentPath;
      }));
      return `left: ${number * (100 / this.steps.length)}%`;
    }
  }
};
</script>

<style scoped>

.steps-content{
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-evenly;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: var(--shadow);
  font-family: var(--secondary-font);
  overflow: hidden;
  font-size: 20px;
  position: relative;
}

.steps-content .step {
  float: left;
  text-align: center;
  padding: 8px;
  color: #4d4d4d;
  z-index: 2;
  position: relative;
}
.steps-content .step.active {
  color: #fff;
  font-weight: 600;
}

.fake-background {
  position: absolute;
  bottom: 0;
  top: 0;
  background-color: var(--primary);
  z-index: 1;
  left: 0;
  border-radius: 25px;
}
  @media (max-width: 1024px) {
    .steps-content {
      font-size: 14px;
    }
    .steps-content .step{
      padding: 8px;
    }
  }

  @media (max-width: 768px) {
    .steps-content {
      font-size: 13px;
    }
    .steps-content .step{
      padding: 6px;

    }
  }

</style>
